import PageLayout, { Section } from "./PageLayout";
import { Smartphone, Tv, Laptop, Tablet, Cast, Globe } from "lucide-react";

const DEVICES = [
  { icon: Globe, name: "Web", desc: "Stream right in your browser. Chrome 90+, Safari 14+, Firefox 88+, Edge 90+.", q: "Up to 4K HDR (Premium plan)" },
  { icon: Smartphone, name: "iPhone & iPad", desc: "iOS 14 or later. Download for offline viewing on Standard & Premium plans.", q: "Up to 1080p" },
  { icon: Smartphone, name: "Android", desc: "Android 8.0 or later. AirPlay & Chromecast supported.", q: "Up to 1080p" },
  { icon: Tablet, name: "Android Tablets", desc: "Optimized layouts for 10\" and 12\" tablets.", q: "Up to 1080p" },
  { icon: Laptop, name: "Mac & PC", desc: "All modern browsers. Picture-in-picture supported.", q: "Up to 4K HDR" },
  { icon: Tv, name: "Smart TVs", desc: "Samsung Tizen, LG webOS, Android TV. Compatible models from 2019+.", q: "Up to 4K HDR" },
  { icon: Cast, name: "Chromecast & AirPlay", desc: "Cast from any phone, tablet or laptop to your TV.", q: "Up to 1080p" },
  { icon: Tv, name: "Apple TV", desc: "tvOS 14 or later, 4th generation Apple TV and newer.", q: "Up to 4K HDR" },
];

export default function Devices() {
  return (
    <PageLayout
      eyebrow="Devices"
      title="Watch on every screen."
      subtitle="Djino Stream follows you from your phone to your TV — and remembers exactly where you left off."
    >
      <Section>
        <div className="grid sm:grid-cols-2 gap-4">
          {DEVICES.map((d, i) => (
            <div key={i} className="bg-[#0d0d0d] border border-white/5 rounded-xl p-6 hover:border-[#E50914]/40 transition" data-testid={`device-${i}`}>
              <div className="flex items-center gap-3 mb-3">
                <div className="w-11 h-11 rounded-lg bg-[#E50914]/15 text-[#E50914] flex items-center justify-center">
                  <d.icon size={22} />
                </div>
                <div className="font-bold text-lg" style={{ fontFamily: "Outfit" }}>{d.name}</div>
              </div>
              <p className="text-sm text-[#bbb] mb-3 leading-relaxed">{d.desc}</p>
              <div className="text-xs text-[#888] uppercase tracking-wider">Quality: <span className="text-[#E50914]">{d.q}</span></div>
            </div>
          ))}
        </div>
      </Section>

      <Section title="Connection requirements">
        <div className="bg-[#0d0d0d] border border-white/5 rounded-xl p-6">
          <table className="w-full text-sm">
            <thead className="text-[#888] text-xs uppercase tracking-wider">
              <tr className="border-b border-white/5">
                <th className="text-left py-2">Quality</th>
                <th className="text-left py-2">Recommended speed</th>
                <th className="text-left py-2">Available on</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-white/5"><td className="py-3">SD</td><td className="py-3 text-[#aaa]">3 Mbps</td><td className="py-3 text-[#aaa]">All plans</td></tr>
              <tr className="border-b border-white/5"><td className="py-3">HD</td><td className="py-3 text-[#aaa]">5 Mbps</td><td className="py-3 text-[#aaa]">All plans</td></tr>
              <tr className="border-b border-white/5"><td className="py-3">Full HD</td><td className="py-3 text-[#aaa]">10 Mbps</td><td className="py-3 text-[#aaa]">Standard, Premium</td></tr>
              <tr><td className="py-3">4K Ultra HD + HDR</td><td className="py-3 text-[#aaa]">25 Mbps</td><td className="py-3 text-[#aaa]">Premium only</td></tr>
            </tbody>
          </table>
        </div>
      </Section>
    </PageLayout>
  );
}
